import React, { useRef } from 'react'

import { useMonaco } from '@monaco-editor/react'

import MergetagPopover from './Popover'

const MODE_LABELS = {
  plain_text: 'Text',
  json: 'JSON',
  xml: 'XML',
  html: 'HTML',
  javascript: 'JavaScript',
  typescript: 'TypeScript',
  css: 'CSS',
}

export default function MergetagEditorFrame({ children, mergetags = [], mode, label, disabled, onOpen, hint = 'Click \'Mergetag\' to insert a mergetag' }) {
  const monaco = useMonaco()
  const wrapperRef = useRef(null)

  const handleInsert = tag => {
    const editor = monaco?.editor.getEditors().find(editor => wrapperRef.current?.contains(editor.getContainerDomNode()))
    const selection = editor?.getSelection()

    if (!editor || !selection) {
      return
    }

    editor.executeEdits('mergetag', [{ range: selection, text: `{${tag}}`, forceMoveMarkers: true }])
    editor.focus()
  }

  return <div ref={wrapperRef}>
    <div className='flex items-stretch justify-between border border-b-0 rounded-t-xs twy-border-base twy-bg-base-neutral'>
      <span className='flex items-center px-3 py-2 twy-text-base-neutral'>
        {label || MODE_LABELS[mode] || mode || 'Text'}
      </span>
      <div className='flex border-l twy-border-base'>
        <MergetagPopover mergetags={mergetags} onSelect={handleInsert} onOpen={onOpen} disabled={disabled} />
      </div>
    </div>
    {children}
    <span className='block mt-1 text-sm font-bold twy-text-base-neutral'>
      {hint}
    </span>
  </div>
}
